/**
 * Mount on engine-outputs, not the collaboration /view report.
 *
 *   <ComputedSurfaces source={engineOutputs} />
 *
 * Skipped policy_deductions: this file is silent. FinalCalculationCard owns the
 * single NOT RUN strip.
 */
import React from 'react';
import PolicyMatrixCard from './PolicyMatrixCard';
import OffsetsStrip from './OffsetsStrip';
import {
  identityHolds,
  isPolicyDeductionsSkipped,
  pickOffsetRows,
  pickPolicyDeductions,
  pickPolicyFacts,
} from './pickComputedSurfaces';
import StateChip from '../shared/StateChip';
import FinancialValue from '../shared/FinancialValue';

function asNumber(v: unknown): number | undefined {
  if (v === undefined || v === null || v === '') return undefined;
  const n = typeof v === 'number' ? v : Number(v);
  return Number.isFinite(n) ? n : undefined;
}

function WaterfallIdentity({ source }: { source: unknown }) {
  const pd = pickPolicyDeductions(source);
  if (!pd || isPolicyDeductionsSkipped(pd)) return null;
  const ok = identityHolds(pd);
  if (ok === null) return null;
  return (
    <div className="mb-6 flex items-center justify-between gap-4 rounded-md border border-[var(--color-border)] bg-[var(--color-bg-surface)] px-5 h-12">
      <span className="text-[11px] font-medium uppercase tracking-[0.08em] text-[var(--color-text-muted)]">
        Control · gross − deductions == net_claim
      </span>
      <div className="flex items-center gap-3">
        <FinancialValue value={asNumber(pd.gross_loss)} compact />
        <span className="text-[11px] text-[var(--color-text-muted)]">−</span>
        <FinancialValue value={asNumber(pd.total_deductions)} compact contra />
        <span className="text-[11px] text-[var(--color-text-muted)]">=</span>
        <FinancialValue value={asNumber(pd.net_claim)} compact />
        <StateChip state={ok ? 'verified' : 'needs-human'} text={ok ? 'Identity holds' : 'Identity broken'} mono />
      </div>
    </div>
  );
}

export default function ComputedSurfaces({ source }: { source: unknown }) {
  const facts = pickPolicyFacts(source);
  const offsets = pickOffsetRows(source);
  return (
    <>
      <PolicyMatrixCard facts={facts} />
      <WaterfallIdentity source={source} />
      <OffsetsStrip rows={offsets} />
    </>
  );
}
